import ApplicationRecord from './ApplicationRecord';

export default class Communication
  extends ApplicationRecord({
    /**
   * @type {String}
   */
    id: '#Communication',
    Content: '',
  }) {}



// WEBPACK FOOTER //
// ./src/models/Communication.js